<template>
  <div class="live-stream-container">
    <div class="SidebuttonContainer" :class="{openSideButton: !data.minimized}">
      <!---div>
        intentionally commented out - TG
        <div class="maximizeButton" @click='maximizeCaller()' :class="{blueButton: data.openCaller}" v-if="!data.openCaller">
          <i class="zmdi zmdi-phone"></i>
        </div>
        <div class="maximizeButton" @click='minimizeCaller()' :class="{blueButton: data.openCaller}" v-if="data.openCaller">
          <i class="zmdi zmdi-phone"></i>
        </div>
      </div--->

      <div class="maximizeButton" @click='maximize()' :class="{blueButton: !data.minimized && data.openVideo}" v-if="data.minimized || !data.openVideo">
        <i class="zmdi zmdi-camera"></i>     
      </div>
      <div class="maximizeButton" @click='minimize()' :class="{blueButton: !data.minimized && data.openVideo}" v-if="!data.minimized && data.openVideo">
        <i class="zmdi zmdi-camera"></i>     
      </div>

      <div v-if='this.resourcesEnabled'>
        <div class="maximizeButton" id="resourceButton" @click='maximizeResources()' :class="{blueButton: !data.minimized && data.openResources}" v-if="!data.openResources">
          <i class="zmdi zmdi-library"></i>  
        </div>
        <div class="maximizeButton" id="resourceButton" @click='minimizeResources()' :class="{blueButton: !data.minimized && data.openResources}" v-else>
          <i class="zmdi zmdi-library"></i>  
        </div>
      </div>

      <div v-if='this.user.frn_phonecodeid'>
        <div class="maximizeButton dialerButton" @click='maximizeDailer()' :class="{blueButton: data.openDailer}" v-if="!data.openDailer">
          <i class="zmdi zmdi-dialpad"></i>
        </div>
        <div class="maximizeButton dialerButton" @click='minimizeDailer()' :class="{blueButton: data.openDailer}" v-else>
          <i class="zmdi zmdi-dialpad"></i>
        </div>
      </div>
    </div>

    <caller v-if="data.openCaller"/>

    <dialer v-if="data.openDailer"/>

    <resources v-if="data.openResources" :videoOpen="data.openVideo" :callerOpen="data.openCaller" :dialerOpen="data.openDailer"/>

    <div class="video-container" v-if='!data.minimized && data.openVideo'>
      <h3 class="agentNameDiv"> 
        Hi <span id="match" class="agentName name">{{data.detectedName}}</span>
      </h3>

      <div class="live-stream-screen" id="canvas" v-loading="loading">
        <label v-if='!this.detector.isRunning' class="clickToView"> Click the camera button to activate video feed.</label>

        <div v-if='this.detector.isRunning' class='sentiment' @click="tout">
          <img id="green" src="https://assets-cdn.carwars.com/cx/very-pleased.svg">
          <img id="red" src="https://assets-cdn.carwars.com/cx/very-displeased.svg">
          <img id="yellow" src="https://assets-cdn.carwars.com/cx/neutral.svg" >
        </div>

        <div v-else class="live-stream-cam-btn" @click="correctWebcam()">
          <i class='zmdi zmdi-camera'></i>    
        </div>
      </div>
    </div>

    <!-- Biometric ToS popup-->
    <article class='popupBG' v-if='this.showTos'>
      <div class='popup wide'>
        <div class='title'>
          <h2>Biometric Information Terms of Service</h2>
          <div  @click='cancelTos()' class='close'></div>
        </div>

        <div class='content scroll'>
          <p class='disclaimer'><b>Important: Read Carefully. By accessing or using Car Wars and/or Call Box proprietary software program (the "Service"), the individual or entity accessing the Service, hereinafter referred to herein as "You" and "Your") agree to be bound by these terms of Service (the "Terms"). If You do not agree to these Terms, You must not access or use the Service, and You must notify Call Box within five (5) days regarding same.</b></p>
          <p class='disclaimer'>Call Box is pleased to offer You access to, and participation in, the Service. You understand and acknowledge that use of the Service may include the collection of biometric identifiers and biometric information (defined below) from You and possibly other third parties. In accordance with Your use of the Service and in consideration for providing You with access and use of the Service, You hereby understand and agree to the Terms specified herein.</p>
          <p class='disclaimer'><b>Biometric Data</b></p>
          <p class='disclaimer'>As used herein, "biometric identifier" means a retina or iris scan, fingerprint, voiceprint, or scan of hand or face geometry. Biometric identifiers do not include writing samples, written signatures, photographs, human biological samples used for valid scientific testing or screening, demographic data, tattoo descriptions, or physical descriptions such as height, weight, hair color, or eye color. Biometric identifiers do not include information captured from a patient in a health care setting or information collected, used, or stored for health care treatment, payment, or operations under the federal Health Insurance Portability and Accountability Act of 1996.</p>
          <p class='disclaimer'>"Biometric information" means any information, regardless of how it is captured, converted, stored, or shared, based on an individual’s biometric identifier used to identify an individual. Biometric information does not include information derived from items or procedures excluded under the definition of biometric identifiers.</p>
          <p class='disclaimer'>Biometric identifiers and biometric information shall be collectively referred to herein as "Biometric Data."</p>
          <p class='disclaimer'><b>Purpose for Collection of Biometric Data</b></p>
          <p class='disclaimer'>Call Box collects, stores, and uses Biometric Data solely for the purpose of using such Biometric Data for live and historical reporting metrics to present to our users for our users' use (the "Purpose").</p>
          <p class='disclaimer'><b>Retention of Biometric Data</b></p>
          <p class='disclaimer'>Call Box shall retain Your Biometric Data only until, and shall request that its users permanently destroy such Biometric Data upon the earlier of the following (the "Retention Schedule"):</p>
          <ol class='disclaimer'>
            <li>The Purpose has been satisfied; or</li>
            <li>Within 30 days from deactivation of the user the Biometric Data belongs to.</li>
          </ol>
          <p class='disclaimer'><b>Disclosure to Third Parties</b></p>
          <p class='disclaimer'>Call Box shall not disclose or disseminate any Biometric Data collected from You through the Service to any third party (other than its users in accordance with the Purpose) without first obtaining written consent from You.</p>
          <p class='disclaimer'><b>Data Storage</b></p>
          <p class='disclaimer'>Call Box shall use a reasonable standard of care to store, transmit and protect from disclosure any paper or electronic Biometric Data collected through the Service. Such storage, transmission, and protection from disclosure shall be performed in a manner that is the same as or more protective than the manner in which Call Box stores, transmits, and protects from disclosure other confidential and sensitive information, including personal information that can be used to uniquely identify an individual or an individual’s account or property, such as genetic markers, genetic testing information, account numbers, PINs, driver’s license numbers and social security numbers.</p>
          <p class='disclaimer'><b>Disclosure and Authorization</b>
          <p class='disclaimer'><b>By executing these Terms, You consent, acknowledge and agree that Call Box has Your authorization and consent to collect, capture, and otherwise obtain your Biometric Data from you for the Purpose to be shared with our users.</b></p>
          <p class='disclaimer'><b>You understand that You are free to decline to provide Biometric Data to Call Box and its users. You may revoke this consent at any time by notifying Call Box in writing to the address below. By executing below You voluntarily consent to Call Box’s collection, storage, and use of Biometric Data and further consent to Call Box utilizing such Biometric Data to generate reporting for its users.</b></p>
        </div>

        <div class="buttons">
          <button @click='acceptTos()'>Proceed</button>
        </div>
      </div>

      <div class='popupCloseWrap' @click='cancelTos()'></div>
    </article>

    <!--- choose phonecode pop-->
    <article class='popupBG' v-if='data.showPop'>
      <div class='popup'>
        <div class='title'>
          <h2>Select Your Name</h2>
          <div  @click='hidePop()' class='close'></div>
        </div>

        <div class='content'>
          <select v-model='data.item'>
            <option default disabled selected>Select your name</option>
            <option v-for='item in lenameList' :value='item'>{{item.lename}}</option>
          </select>
        </div>

        <div class="buttons">
          <button :disabled='data.item == ""' @click="enrollme(data.item)">SAVE</button>
        </div>
      </div>

      <div class='popupCloseWrap' @click='hidePop()'></div>
    </article>
  </div>
</template>


<script>
  import $ from 'jquery'
  import { mapState, mapGetters } from 'vuex'
  import axios from 'axios'
  require('../assets/css/videoViewer.css')

  async function getfaceid(that) {
    if (that.detectedName === true){
      return 0
    } else { 

      that.detectedName = true
      var data, phonecodeid
      let endpoint = "https://facialrecog.callbox.com/upload_image/" + that.account.lskinid
      Webcam.snap( function(data_uri) {
        that.data_uri = data_uri
        Webcam.upload(data_uri, endpoint, async function(code, text) {
          data = JSON.parse(text)

          phonecodeid = data.phonecodeid

          if (phonecodeid === "unknown") {
            that.data.count = that.data.count + 1
            that.detectedName = false
            if (that.data.count >=4) {
              that.detector.removeEventListener();
              document.getElementById("match").innerHTML = ''
              that.data.count = 0
              that.detector.stop();
              that.loading = false;
              Webcam.reset();
              that.data.showPop = true;
              return 1
            }
          } else if (data.error) {return 0}
          else if (phonecodeid === "No face found") {
            that.data.detectedName = ""
            that.detectedName = false
          } else {
            that.data.detectedPhonecodeid = phonecodeid;

            try {
              let endpoint2 = '/lename/'
              let url = endpoint2 + that.account.lskinid +'/'+ phonecodeid
              let res = await that.axios.get(url, {responseType: 'json'})

              document.getElementById("match").innerHTML = res.data.lename
              that.data.detectedName = res.data.lename
            } 
            catch(err) {console.log(err.message)}
          }
        })
      })
    }  
  }
import resources from '@/components/resources'
import caller from '@/components/caller'
import dialer from '@/components/dialer'
  export default {
    name: 'featureContainer',
    props: ['currentView', 'isCallCenter', 'hProduct'],
    components:{
      resources,
      caller,
      dialer
    },
    data: function () {
      return {
        detector: false,
        loading: false,
        activeNames: ['0'],
        // color: '#409EFF',
        joy: 0,
        detectedName: false,
        smile: 0,
        lenameList: [],
        data_uri:0,
        showTos: false,
        videoViewer: {},
        data: {
          detectedName: '',
          count: 0,
          timer: 60,
          item: '',
          showPop: false,
          detectedPhonecodeid: '',
          showSecondPop: false,
          minimized: true,
          seeTos: false,
          openResources: false,
          openVideo: false,
          openCaller: false,
          hasJive: true,
          openDailer: false
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.user,
        account: state => state.account,
        resourcesEnabled: state => state.resourcesEnabled,
        conversation: state => state.conversation,
      }),
      ...mapGetters([
        'getTosSet',
        'getSeeTos', 
      ])
    },
    mounted: function () {
      var intHProduct = parseInt(this.hProduct); 
      var CallCenterHproduct = [24];
      if (this.user.Phonecode === null) {
        this.data.minimized = true
        this.minimize()
        this.minimizeResources()
      } else if (CallCenterHproduct.indexOf(intHProduct) !== -1) {
        this.data.minimized = false
        this.data.openVideo = true
        this.data.openResources = true
        if (this.user.frn_phonecodeid) {
          this.data.openDailer = true
          this.maximizeDailer()
        }
        this.maximize()
        this.openCallerComp()
      } else {
        this.data.minimized = true
        this.minimize()
      }
    },
    methods: {
      openCallerComp:function(){
        if (this.data.hasJive && this.conversation.displayNum) {
          this.data.openCaller = true
          this.data.minimized = false;
        }
      },
      maximizeResources: function(){
        if (this.resourcesEnabled) {
          this.data.openResources = true
          if (this.data.minimized) {
            this.data.minimized = false;
          }
        }
      },
      maximizeDailer: function(){
        this.data.openDailer = true
        if (this.data.minimized) {
          this.data.minimized = false;
        }
      },
      minimizeResources: function(){
        if (this.resourcesEnabled) {
          this.data.openResources = false
          if (!this.data.openVideo && !this.data.openCaller && !this.data.openDailer) {
            this.data.minimized = true;
          }
        }
      },
      minimizeDailer:function(){
        this.data.openDailer = false
        if (!this.data.minimized && !this.data.openResources && !this.data.openCaller && !this.data.openDailer) {
          this.data.minimized = true;
        }
      },
      minimizeCaller:function(){
        this.data.openCaller = false
        if (!this.data.minimized && !this.data.openResources && !this.data.openCaller && !this.data.openDailer) {
          this.data.minimized = true;
        }
      },
      minimize: function (){
        this.showTos = false;
        this.data.openVideo = false;
        this.tout();

        if (!this.data.minimized && !this.data.openResources && !this.data.openCaller && !this.data.openDailer) {
          this.data.minimized = true;
        }
      },
      maximize: function () {
        // maximize video
        if (this.user.Phonecode === null) {
          //do nothing
        } else { 
          if (this.data.minimized) {
            this.data.minimized = false;
          }
          this.data.openVideo = true
          /*this.webCamInitial()*/
        }
      },
      correctWebcam: function () {
        if (this.getTosSet === false) {
          this.showTos = true
        } else {
          this.webCamInitial()
          this.tout()
        }
      },
      webCamInitial: function () {
        var that = this;
        const divRoot = $("#canvas")[0];
        const width = 640;
        const height = 480;
        var state;
        var presenceState_here 
        var presenceState = 'OFF'
        var count = 0
        var timing = setInterval(function() {
          that.detectedName = false
          }, that.data.timer * 1000);
            
        const FACE_MODE = affdex.FaceDetectorMode.SMALL_FACE;

        let endpoint  = '/lename/'
        let url = endpoint + this.account.lskinid
        axios.get(url).then(response => {
          this.lenameList = response.data
        })

        //Construct a FrameDetector and specify the image width / height and face detector mode.
        this.detector = new affdex.CameraDetector(divRoot, width, height, FACE_MODE);

        //Enable detection of all Expressions, Emotions and Emojis classifiers.
        this.detector.detectAllEmotions();
        this.detector.detectAllExpressions();
        this.detector.detectAllEmojis();
        this.detector.detectAllAppearance();

        //Add a callback to notify when the detector is initialized and ready for runing.
        this.detector.addEventListener("onInitializeSuccess", function() {
          that.$message({
            message: 'Detection is initialized!',
            type: 'success'
          });
          that.loading = false;
          //Display canvas instead of video feed because we want to draw the feature points on it
          $("#face_video_canvas").css("display", "block");
          $("#face_video").css("display", "none");
        });

        this.detector.addEventListener("onWebcamConnectSuccess", function() {
          that.$notify({
            title: 'Success',
            message: 'Webcam access allowed',
            type: 'success'
          });
        });

        this.detector.addEventListener("onWebcamConnectFailure", function() {
          that.$notify({
            title: 'Failure',
            message: 'Webcam access denied',
            type: 'danger'
          });
          $('#canvas').css('background', '#505f72');
          $('#face_video').css('background', '#505f72');
          $('.el-loading-parent--relative').css('background-color', '#505f72')
          $('.circular').hide();
          $('.el-loading-mask').hide();
        });

        this.detector.addEventListener("onImageResultsSuccess", function(faces, image, timestamp) {
          getfaceid(that)

          if(faces.length == 0) {
            count = count + 1
            if (count >= 800) {
              $(".red-dotVV-change").css({"background": "#dc4747"})
              presenceState_here = "OFF"
              if (presenceState != presenceState_here) {
                presenceState = "OFF"
                var time = $.now();
                var ispresent = 0
                that.presenceLogging(ispresent, time)
              }
              count = 0
            }
          } else if(faces.length > 0) {
            count = 0
            $(".red-dotVV-change").css({"background": "#00ff00"})
            presenceState_here = "ON"
            if (presenceState != presenceState_here) {
              presenceState = "ON"
              var time = $.now();
              var ispresent = 1
              that.presenceLogging(ispresent, time)
            }
          }

          if(faces.length > 0) {      
            var detectedValence = faces[0].emotions['valence'];
            if (detectedValence >= 20) {
              var statehere = "pos";
              if (state != statehere) {
                var start_time = $.now();
                state = 'pos';
                // that.logging(start_time, state);
              }
              $("#green").css({"display":"block"});
              $("#yellow").css({"display":"none"});
              $("#red").css({"display":"none"});        
            } else if (detectedValence < 20 && detectedValence >= -20) {
              var statehere = "neu";
              if (state != statehere) {
                var start_time = $.now();
                state = 'neu';
                // that.logging(start_time, state);
              }
              $("#green").css({"display":"none"});
              $("#yellow").css({"display":"block"});
              $("#red").css({"display":"none"});
            } else if (detectedValence < -20) {
              var statehere = "neg";
              if (state != statehere) {
                var start_time = $.now();
                state = 'neg';
                // that.logging(start_time, state);
              }
              $("#green").css({"display":"none"});
              $("#yellow").css({"display":"none"});
              $("#red").css({"display":"block"});
            }
            // appearance
            // emotions
            that.anger = faces[0].emotions.anger;
            that.joy = faces[0].emotions.joy;
            // expressions
            that.attention = faces[0].expressions.attention;
            that.smile = faces[0].expressions.smile;
          }
        });
      },
      maximizeCaller:function(){
        this.data.openCaller = true
        this.data.minimized = false
        this.maximizeResources()
      },
      cancelTos: function (){
        this.minimize();
        this.$store.commit({
          type: 'UPDATE_ENROLLMENT',
          accept: false
        })
      },
      acceptTos: function(){     
        this.$store.dispatch('updateEnrollment', { 
          accept: true,
          phonecodeid: this.user.Phonecode.phonecodeid,
          leuserid: this.user.leuserid
        })
        this.showTos = false
        this.data.minimized = false
        $('.convo-container').css('width', 'calc(65% - 40px)')
        this.webCamInitial()
        this.tout()
      },
      showpopup2(item) {
        this.data.item = item
        this.data.showSecondPop = true
      },

      tout() {
        if (this.detector && !this.detector.isRunning) {
          this.detector.start();
          this.loading = true;
          let video = $('#face_video')[0]
    
          Webcam.set({
            width: 320,
            height: 240,
            dest_width: 640,
            dest_height: 480,
            image_format: 'jpeg',
            jpeg_quality: 90,
            force_flash: false,
            flip_horiz: true,
            fps: 45
          });
          Webcam.attach(video)
        }
        else if (this.detector && this.detector.isRunning) {
          this.detector.removeEventListener();
          this.data.detectedName = ""
          this.detectedName === true
          var time = $.now()
          this.presenceLogging(0, time)
          
          this.detector.stop();
          this.loading = false;
          this.$message({
            message: 'Camera stopped.',
            type: 'warning'

          });
          Webcam.reset()
        };

      },

      async logging(start_time, state) {
        let url = '/detectedEmotion/';
        let note = {
          start_time: start_time,
          emotion: state,
        };
        let result = await this.axios.post(url, note);
      },

      hidePop: function () {
      this.data.showPop = false;
      },

      hidePop2: function () {
      this.data.showSecondPop = false;
      },

      async enrollme(item) {
        this.data.showPop = false;
        let endpoint = "https://facialrecog.callbox.com/enrollment/"
        let url = endpoint  + item.phonecodeid + '/' + this.account.lskinid
        var data_uri = this.data_uri
        let that = this
        Webcam.upload(data_uri, url, async function(code, text) {
          that.$message({
            message: text,
            type: 'success'
          });
        })
      },

      async presenceLogging(ispresent, time) {
        let url = "/presence/";
        let note = {
          lskinid: this.account.lskinid,
          phonecodeid: this.data.detectedPhonecodeid,
          isavailable: ispresent,
          last_update: time
        }
        // console.log(note)
        let result = await this.axios.post(url, note);
      }
      
    }
  }
</script>